import TxPage from "../components/TxPage";
import { PENERIMAAN_TABS } from "../lib/constants";

export default function Penerimaan() {
  return (
    <TxPage
      title="Penerimaan Dana"
      subtitle="Catat seluruh dana masuk: Infaq, Zakat, dan Sedekah/DSKL"
      tabs={PENERIMAAN_TABS}
      direction="in"
      partyField="donor"
      partyLabel="Donatur / Muzakki"
      testPrefix="penerimaan"
    />
  );
}
